import React from 'react'
import classNames from 'classnames'

// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles'

// @material-ui/icons
import People from '@material-ui/icons/People'
import Favorite from '@material-ui/icons/Favorite'
import DirectionsRunning from '@material-ui/icons/DirectionsRun'
import FormatBold from '@material-ui/icons/FormatBold'
import RecordVoiceOver from '@material-ui/icons/RecordVoiceOver'

// core components
import GridContainer from 'components/Grid/GridContainer.jsx'
import GridItem from 'components/Grid/GridItem.jsx'
import NavPills from 'components/NavPills/NavPills.jsx'

import teamStyle from 'assets/jss/material-kit-react/views/landingPageSections/teamStyle.jsx'

import bold from 'assets/img/values/bold.jpg'
import compassion from 'assets/img/values/compassion.jpg'
import confident from 'assets/img/values/confident.jpg'
import eager from 'assets/img/values/eager.jpg'
import leader from 'assets/img/values/leader.jpg'

const items = ({ classes }) => {
    const imageClasses = classNames(classes.imgRaised, classes.imgFluid)

    return [
        {
            tabButton: 'Be A Leader',
            tabIcon: People,
            tabContent: (
                <GridContainer justify="center">
                    <GridItem md={12}>
                        <img src={leader} className={imageClasses} alt="" />
                        <span>
                            <h4 className={classes.description}>
                We believe in founding our perspective in facts and powering our
                actions with enthusiasm for the problems we are facing. In order
                to lead, in every way, we need to make sure to speed through
                trivial matters and prevent standing still.
                            </h4>
                        </span>
                    </GridItem>
                </GridContainer>
            )
        },

        {
            tabButton: 'Be Confident',
            tabIcon: RecordVoiceOver,
            tabContent: (
                <GridContainer justify="center">
                    <GridItem md={12}>
                        <img src={confident} className={imageClasses} alt="" />
                        <span>
                            <h4 className={classes.description}>
                We are not here for improving the “now”. We are here to improve
                the future. We welcome opportunities to tackle big customer
                problems because we believe we can always raise the bar of the
                expectations of both our customers and ourselves.
                            </h4>
                        </span>
                    </GridItem>
                </GridContainer>
            )
        },

        {
            tabButton: 'Be Eager',
            tabIcon: DirectionsRunning,
            tabContent: (
                <GridContainer justify="center">
                    <GridItem md={12}>
                        <img src={eager} className={imageClasses} alt="" />
                        <span>
                            <h4 className={classes.description}>
                We try to seize the initiative whenever possible. Good ideas
                abide by no boundaries and neither should our thoughts. Doing
                so, as a team, makes it possible for us to succeed in delivering
                great products we are proud of.
                            </h4>
                        </span>
                    </GridItem>
                </GridContainer>
            )
        },

        {
            tabButton: 'Be Compassionate',
            tabIcon: Favorite,
            tabContent: (
                <GridContainer justify="center">
                    <GridItem md={12}>
                        <img src={compassion} className={imageClasses} alt="" />
                        <span>
                            <h4 className={classes.description}>
                Understanding the perspective of fellow workers is central to
                the best forms of collaboration. The sense of united compassion
                we create in our team allows us to empathize with our customers
                like few others can. Our goal is to make products that truly
                change our customers for the better.
                            </h4>
                        </span>
                    </GridItem>
                </GridContainer>
            )
        },

        {
            tabButton: 'Be Bold',
            tabIcon: FormatBold,
            tabContent: (
                <GridContainer justify="center">
                    <GridItem md={12}>
                        <img src={bold} className={imageClasses} alt="" />
                        <span>
                            <h4 className={classes.description}>
                We wouldn’t have had planes without several, seemingly crazy,
                people who dreamt big and put their lives on the line to prove
                their idea was possible. Being willing to expose yourself to
                failure and picking yourself up and learning from those failures
                in integral to improving yourself and your work. Only those
                courageous and dedicated enough can get full value.
                            </h4>
                        </span>
                    </GridItem>
                </GridContainer>
            )
        }
    ]
}

class ValueSection extends React.Component {
    render() {
        const { classes } = this.props

        return (
            <div className={classes.section}>
                <GridContainer justify="center">
                    <GridItem md={12}>
                        <h2 className={classes.title}>Our Values</h2>
                        <h4 className={classes.description}>
              Click on the values below to learn more about how we choose to
              operate.
                        </h4>

                        <NavPills alignCenter color="primary" tabs={items(this.props)} />
                    </GridItem>
                </GridContainer>
            </div>
        )
    }
}

export default withStyles(teamStyle)(ValueSection)



// WEBPACK FOOTER //
// ./src/views/AboutUs/Sections/ValueSection.jsx